<div class="app-resource-rule-selector-container full-width">
  <div
    class="guide-text"
    *ngIf="getFormArray(ruleForm.get('ruleFormArray'))?.controls?.length > 0; else tagSelectorHeadingContent"
  >
    Select resources where...
  </div>
  <ng-template #tagSelectorHeadingContent> No rules are applied. </ng-template>
  <form [formGroup]="ruleForm" class="full-width">
    <div
      class="full-width rule-selector"
      id="tag-array"
      formArrayName="ruleFormArray"
      cdkDropList
      [cdkDropListData]="getFormArray(ruleForm.get('ruleFormArray')).controls"
      (cdkDropListDropped)="dropGroup($event)"
    >
      <div
        class="full-width rule-or-row"
        *ngFor="let ruleControl of getFormArray(ruleForm.get('ruleFormArray')).controls; let i = index"
        cdkDrag
        [cdkDragDisabled]="false"
        [ngSwitch]="isFormGroup(ruleControl)"
      >
        <div *ngSwitchCase="true" class="and-group-wrapper full-width">
          <!-- AND group Box starts -->
          <div class="and-group-and comparator half-margin-right">{{ i !== 0 ? 'or' : '' }}</div>
          <div [formGroupName]="i" class="and-group flex-center-row full-width">
            <div class="group-content flex-grow full-width">
              <div formArrayName="rules">
                <!-- text for future OR row when supported in groups -->
                <!-- <div *ngIf="i !== 0" class="guide-text">Any of the following are true…</div> -->
                <div *ngIf="i !== 0" class="guide-text">All of the following are true…</div>
                <div
                  *ngFor="let innerRuleControl of getFormArray(ruleControl.get('rules')).controls; let j = index"
                  [formGroupName]="j"
                  class="flex-center-row tag-row"
                >
                  <div class="and-label operator">{{ j === 0 ? '' : 'and' }}</div>
                  <app-custom-rule-dropdown
                    formControlName="filterType"
                    cssClass="arpio-input full-width rule-type"
                    [class.ruletype-expanded-width-select]="
                      showResourceTypeSelect(innerRuleControl) || showResourceGroupSelect(innerRuleControl)
                    "
                    [options]="filterTypeOptions"
                    placeholder="Select type..."
                    (selectionChanged)="onFilterTypeChange(innerRuleControl)"
                  >
                  </app-custom-rule-dropdown>
                  <div class="rule-overflow-wrapper" *ngIf="showTagSelect(innerRuleControl)">
                    <input
                      *ngIf="isTagsLoading"
                      type="text"
                      class="arpio-input row-element full-width"
                      [value]="innerRuleControl.get('tagName')?.value || ''"
                      disabled
                      placeholder="Loading tags..."
                    />
                    <app-custom-rule-dropdown
                      *ngIf="!isTagsLoading"
                      formControlName="tagName"
                      cssClass="arpio-input row-element full-width"
                      [options]="tagNameOptions"
                      [allowAddNew]="true"
                      [storageKey]="getStorageKey('tag-name')"
                      placeholder="Select tag..."
                      addNewPlaceholder="Search or add new tag..."
                      (selectionChanged)="onTagNameChange(innerRuleControl)"
                      (optionAdded)="onTagNameOptionAdded($event)"
                      (optionRemoved)="onTagNameOptionRemoved($event)"
                    >
                    </app-custom-rule-dropdown>
                  </div>
                  <app-custom-rule-dropdown
                    formControlName="operator"
                    cssClass="has-value-div comparator arpio-input full-width"
                    [options]="getOperatorOptions(i, j)"
                    placeholder="Select operator..."
                  >
                  </app-custom-rule-dropdown>
                  <div class="rule-overflow-wrapper" *ngIf="showTagSelect(innerRuleControl)">
                    <input
                      *ngIf="isTagsLoading"
                      type="text"
                      class="arpio-input row-element full-width"
                      [value]="innerRuleControl.get('tagValue')?.value || ''"
                      disabled
                      placeholder="Loading tag values..."
                    />
                    <app-custom-rule-dropdown
                      *ngIf="!isTagsLoading"
                      formControlName="tagValue"
                      cssClass="arpio-input row-element full-width"
                      [options]="getTagValueOptions(innerRuleControl.get('tagName')?.value || '')"
                      [allowAddNew]="true"
                      [storageKey]="getStorageKey('tag-value')"
                      placeholder="Any value"
                      addNewPlaceholder="Search or add new tag value..."
                      (optionAdded)="onTagValueOptionAdded($event, innerRuleControl.get('tagName')?.value)"
                      (optionRemoved)="onTagValueOptionRemoved($event, innerRuleControl.get('tagName')?.value)"
                    >
                    </app-custom-rule-dropdown>
                  </div>
                  <app-custom-rule-dropdown
                    *ngIf="showResourceTypeSelect(innerRuleControl)"
                    formControlName="resourceType"
                    cssClass="arpio-input full-width"
                    [options]="resourceTypeOptions"
                    placeholder="Select resource type..."
                  >
                  </app-custom-rule-dropdown>
                  <app-custom-rule-dropdown
                    *ngIf="showResourceGroupSelect(innerRuleControl)"
                    formControlName="resourceGroup"
                    cssClass="arpio-input full-width"
                    [options]="resourceGroupOptions"
                    placeholder="Select resource group..."
                    [allowAddNew]="true"
                    [storageKey]="getStorageKey('resource-group')"
                    addNewPlaceholder="Search..."
                  >
                  </app-custom-rule-dropdown>
                  <div class="remove-btn margin-right" (click)="removeTagAt(i, j)" *ngIf="!readonly">
                    <i class="fa-utility-duo fa-semibold fa-trash" title="Remove this rule"></i>
                  </div>
                  <div class="and-group-controls-container">
                    <div class="and-btn margin-right" (click)="addOrRow(i, j)" *ngIf="!readonly">
                      <i class="fa-utility fa-semibold fa-plus" title="Add rule in this group"></i>
                    </div>
                    <div class="margin-right" *ngIf="!readonly">
                      <div class="remove-btn" (click)="removeAllRowsInGroup(i)">
                        <i class="fa-utility-duo fa-semibold fa-trash" title="Remove all rules in this group"></i>
                      </div>
                    </div>
                    <div class="drag-handle-container" cdkDragHandle>
                      <i class="fa-solid fa-grip-vertical drag-handle" aria-hidden="true" title="Drag to reorder"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngSwitchDefault [formGroupName]="i" class="flex-center-row tag-row or-label">
          <!-- OR group Box starts -->
          <div class="or-label or-spacer operator">
            {{ i > 0 ? 'or' : '' }}
          </div>
          <app-custom-rule-dropdown
            formControlName="filterType"
            cssClass="arpio-input full-width rule-type"
            [class.ruletype-expanded-width-select]="
              showResourceTypeSelect(ruleControl) || showResourceGroupSelect(ruleControl)
            "
            [options]="filterTypeOptions"
            placeholder="Select type..."
            (selectionChanged)="onFilterTypeChange(ruleControl)"
          >
          </app-custom-rule-dropdown>
          <div class="rule-overflow-wrapper" *ngIf="showTagSelect(ruleControl)">
            <input
              *ngIf="isTagsLoading"
              type="text"
              class="arpio-input row-element full-width"
              [value]="ruleControl.get('tagName')?.value || ''"
              disabled
              placeholder="Loading tags..."
            />
            <app-custom-rule-dropdown
              *ngIf="!isTagsLoading"
              formControlName="tagName"
              cssClass="arpio-input row-element full-width"
              [options]="tagNameOptions"
              [allowAddNew]="true"
              [storageKey]="getStorageKey('tag-name')"
              placeholder="Select tag..."
              addNewPlaceholder="Search or add new tag..."
              (selectionChanged)="onTagNameChange(ruleControl)"
              (optionAdded)="onTagNameOptionAdded($event)"
              (optionRemoved)="onTagNameOptionRemoved($event)"
            >
            </app-custom-rule-dropdown>
          </div>
          <div class="has-value-div comparator row-element">is</div>
          <div class="rule-overflow-wrapper" *ngIf="showTagSelect(ruleControl)">
            <input
              *ngIf="isTagsLoading"
              type="text"
              class="arpio-input row-element full-width"
              [value]="ruleControl.get('tagValue')?.value || ''"
              disabled
              placeholder="Loading tag values..."
            />
            <app-custom-rule-dropdown
              *ngIf="!isTagsLoading"
              formControlName="tagValue"
              cssClass="arpio-input row-element full-width"
              [options]="getTagValueOptions(ruleControl.get('tagName')?.value || '')"
              [allowAddNew]="true"
              [storageKey]="getStorageKey('tag-value')"
              placeholder="Any value"
              addNewPlaceholder="Search or add new value..."
              (optionAdded)="onTagValueOptionAdded($event, ruleControl.get('tagName')?.value)"
              (optionRemoved)="onTagValueOptionRemoved($event, ruleControl.get('tagName')?.value)"
            >
            </app-custom-rule-dropdown>
          </div>
          <app-custom-rule-dropdown
            *ngIf="showResourceTypeSelect(ruleControl)"
            formControlName="resourceType"
            cssClass="arpio-input full-width"
            [options]="resourceTypeOptions"
            placeholder="Select resource type..."
          >
          </app-custom-rule-dropdown>
          <app-custom-rule-dropdown
            *ngIf="showResourceGroupSelect(ruleControl)"
            formControlName="resourceGroup"
            cssClass="arpio-input full-width"
            [options]="resourceGroupOptions"
            placeholder="Select resource group..."
            [allowAddNew]="true"
            [storageKey]="getStorageKey('resource-group')"
            addNewPlaceholder="Search..."
          >
          </app-custom-rule-dropdown>
          <div class="remove-btn margin-right" (click)="removeTagAt(i, j)" *ngIf="!readonly">
            <i class="fa-utility-duo fa-semibold fa-trash" title="Remove this rule"></i>
          </div>
          <div class="drag-handle-container" cdkDragHandle>
            <i class="fa-solid fa-grip-vertical drag-handle" aria-hidden="true" title="Drag to reorder"></i>
          </div>
        </div>
      </div>
      <div class="flex-row-start items-center gap-4 margin-top" *ngIf="!readonly">
        <a
          id="add-rule-button"
          class="and-btn third-margin-right"
          (click)="addOrRow(getFormArray(ruleForm.get('ruleFormArray')).controls.length - 1)"
        >
          <i class="fa-utility fa-semibold fa-plus half-margin-right" title="Add new rule"></i>
          <span class="underline">Add Rule</span>
        </a>
        <a
          id="add-compound-rule-button"
          class="and-btn"
          (click)="addAndGroup(getFormArray(ruleForm.get('ruleFormArray')).controls.length - 1)"
        >
          <i class="fa-utility fa-semibold fa-plus third-margin-right" title="Add new rule group"></i>
          <span class="underline">Add Compound Rule</span>
        </a>
      </div>
    </div>
  </form>
</div>
